module.exports = __webpack_public_path__ + "static/media/Hero-Banner.neutral.5ce8157c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hero-Banner.neutral.jpg
// module id = 220
// module chunks = 8